/**
 * 巡检管理模块 - 第 5 组（taskManagementOutsourcing / taskManagementRevenue / taskManagementWaterWorks）
 * (src/views/inspectionManagement) 英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '保存': 'Save',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '更多': 'More',
  '批量操作': 'Batch Operations',
  '清空': 'Clear',
  '操作': 'Action',
  '创建时间': 'Created At',
  '是': 'Yes',
  '否': 'No',
  '确定删除吗?': 'Are you sure you want to delete?',
  '收起': 'Collapse',
  '展开': 'Expand',
  '无图片': 'No Image',
  '无文件': 'No File',
  '下载': 'Download',
  '导入': 'Import',
  '导出': 'Export',
  '备注': 'Remark',
  '预览': 'Preview',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',

  // ── 巡检任务列表 ──
  '巡检任务页面': 'Inspection Task Page',
  '巡检结果页面': 'Inspection Result Page',
  '数据列表': 'Data List',
  '地图展示': 'Map View',
  '任务名称': 'Task Name',
  '请输入任务名称': 'Please enter task name',
  '任务状态': 'Task Status',
  '请选择任务状态': 'Please select task status',
  '未分配': 'Unassigned',
  '已分配': 'Assigned',
  '结束': 'Finished',
  '超时未完成': 'Overdue & Unfinished',
  '任务类型': 'Task Type',
  '请选择任务类型': 'Please select task type',
  '临时任务': 'Temporary Task',
  '日常任务': 'Routine Task',
  '巡检计划': 'Inspection Plan',
  '请选择巡检计划': 'Please select inspection plan',
  '巡检任务': 'Inspection Task',
  '请选择巡检任务': 'Please select inspection task',
  '开始时间': 'Start Time',
  '请输入开始时间': 'Please enter start time',
  '结束时间': 'End Time',
  '请输入结束时间': 'Please enter end time',
  '请选择开始时间': 'Please select start time',
  '请选择结束时间': 'Please select end time',
  '执行人员类型': 'Executor Type',
  '请选择执行人员类型': 'Please select executor type',
  '班组': 'Team',
  '成员': 'Member',
  '执行人员': 'Executor',
  '请选择执行人员(班组)': 'Please select executor (team)',
  '请选择执行人员(成员)': 'Please select executor (member)',
  '执行人员(班组/成员)': 'Executor (Team/Member)',
  '分派': 'Assign',
  '确定结束吗?': 'Are you sure to end?',
  '巡检状态': 'Inspection Status',
  '未开始': 'Not Started',
  '进行中': 'In Progress',
  '已完成': 'Completed',
  '未完成': 'Unfinished',
  '更新设备状态': 'Update Device Status',
  '请选择是否正常': 'Please select whether it is normal',
  '是否正常': 'Normal or Not',
  '请输入结果描述': 'Please enter result description',
  '结果描述': 'Result Description',

  // ── 任务分派弹窗 ──
  '任务分派': 'Task Assignment',
  '实施人类型': 'Implementer Type',
  '请选择实施人类型': 'Please select implementer type',
  '指定班组': 'Assign Team',
  '直接指定实施人员': 'Assign Implementer Directly',
  '选择班组': 'Select Team',
  '请选择班组': 'Please select team',
  '选择人员': 'Select Personnel',
  '请选择人员': 'Please select personnel',
  '请输入巡检方案名称': 'Please enter inspection plan name',
  '请输入备注信息': 'Please enter remark',

  // ── 更新任务弹窗 ──
  '更新任务': 'Update Task',
  '巡检路线': 'Inspection Route',
  '路线状态': 'Route Status',
  '请选择路线状态': 'Please select route status',
  '完成': 'Finish',
  '路线类型': 'Route Type',
  '管线': 'Pipeline',
  '路线名称': 'Route Name',
  '里程数': 'Mileage',
  '设备': 'Device',
  '关闭更新内容': 'Close Update Content',
  '打开更新内容': 'Open Update Content',
  '请选择设备是否正常': 'Please select whether the device is normal',

  // ── 任务详情弹窗 ──
  '巡检任务信息': 'Inspection Task Information',
  '任务结束时间': 'Task End Time',
  '计划名称': 'Plan Name',
  '路线-设备信息': 'Route - Device Info',
  '任务实施人员名称': 'Implementer Name',
  '任务分配人员名称': 'Assigner Name',
  '巡检结果': 'Inspection Result',
  '操作人': 'Operated By',
  '操作时间': 'Operation Time',
  '是否存在问题': 'Problem or Not',
  '运行状态': 'Running Status',
  '问题描述': 'Problem Description',
  '解决前照片或视频': 'Photos/Videos Before Resolution',
  '解决后照片或视频': 'Photos/Videos After Resolution',

  // ── 地图展示 ──
  '设备名称': 'Device Name',
  '请输入设备名称': 'Please enter device name',
  '设备类型': 'Device Type',
  '请选择设备类型': 'Please select device type',
  '设备状态': 'Device Status',
  '请选择设备状态': 'Please select device status',
  '巡检历史记录': 'Inspection History',
  '设备编号': 'Device No.',
  '设备经度': 'Device Longitude',
  '设备纬度': 'Device Latitude',

  // ── 注释中出现的词条（保持词典完整）──
  '请输入创建时间': 'Please enter creation time',
}
